import React, { useEffect, useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import Wrapper from '../../../components/Wrapper/Wrapper';
import { connect } from "react-redux";
import TopCard from '../../../components/TopCard/TopCard';
import TapLayout from '../../../components/PageLayout/TabLayOut';
import Grid from '@material-ui/core/Grid';
import MUIDataTable from "mui-datatables";
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { getMonthlyBalancesParty } from '../../../../store/actions/partiesActionCreator';
import { getSinglePartyLedgerData, getSinglePartyPDFReport } from '../../../../store/actions/homeActionCreator';
import { tripTableHeight, tableHeightWithSparkline, tableHeightWithSparklineTab } from "../../../../styleVariables";
import { numberFormat, getTripStartDateFilterValues, getDateInStringDDMMMYYYY, getRequestTimeInMillis } from "../../../../utils/utils";
import {
  TRIP_ACTIONS,
  TRIP_STATUS_DIALOG_TITLES,
  TRIP_STATUS_DIALOG_LABELS,
  TRIP_FILTER_STATUS,
  TRIP_FILTER_STATUS_MAPPING,
  PAYMENT_CHIPS,
  TRIP_STATUS_LABELS
} from "../../../../store/constants";
import { trackEvent } from '../../../../analytics';
import useStyles from '../../css/listing';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import ActionButton from '../../../components/Actions/ActionButton';
import ColumnActions from '../../../components/Actions/ColumnActions';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import LinearProgress from '../../../components/Progress/LinearProgress';
import ReportsDialog from '../../../components/ReportsDialog/ReportsDialog';

const MonthlyBalancesTab = ({ user, location, dispatchGetSinglePartyMonthlyBalancesAction, parties }) => {

  const [reportOpen, setReportOpen] = useState(false);
  const [monthData, setMonthData] = useState("");
  const [monthStartEpoch, setMonthStartEpoch] = useState("");
  const [monthEndEpoch, setMonthEndEpoch] = useState("");

  let history = useHistory();
  const classes = useStyles();
  let path = location && location.pathname ? location.pathname.split("/") : [];
  let partId = "";
  if (path[path.length - 1]) {
    partId = path[path.length - 1];
  }
  useEffect(() => {
    if (partId) {
      dispatchGetSinglePartyMonthlyBalancesAction(partId, () => {
      },
        () => {

        });
    }
  }, [dispatchGetSinglePartyMonthlyBalancesAction]);
  const muiData = parties && parties.singlePartyMonthlyBalances && parties.singlePartyMonthlyBalances.monthlyBalances ? parties.singlePartyMonthlyBalances.monthlyBalances : [];
  const muiColumns = [
    {
      name: "name",
      label: "Month",
      options: {
        filter: true,
        sort: true
      },
    },
    {
      name: "numberOfTripsStarted",
      label: "Trip Started",
      options: {
        filter: true,
        sort: false,
        setCellProps:(value, rowIndex, columnIndex)=>{
          let data = muiData[rowIndex];
          let style = {};
          if(data && data.openingBalance){
            style.borderRight="none";
          }
          return {
            style:style 
          };
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? <span >{Number(value)}</span> : ''
        }
      },
    },
    {
      name: "numberOfTripsSettled",
      label: "Trip Settled",
      options: {
        filter: true,
        sort: false,
        setCellProps:(value, rowIndex, columnIndex)=>{
          let data = muiData[rowIndex];
          let style = {};
          if(data && data.openingBalance){
            style.borderLeft="none";
            style.borderRight="none";
          }
          return {
            style:style 
          };
        },
        customBodyRenderLite: (dataIndex, rowIndex) => {
          let data = muiData[dataIndex];
          if(data && data.openingBalance && data.totalAmount){
            return <span >Opening Balance: {numberFormat(Number(data.totalAmount))}</span> 
          }
          return data.numberOfTripsSettled ? <span >{Number(data.numberOfTripsSettled)}</span> : ''
        }
      },
    },
    {
      name: "totalRevenue",
      label: "Revenue",
      options: {
        filter: true,
        sort: false,
        setCellProps:(value, rowIndex, columnIndex)=>{
          let data = muiData[rowIndex];
          let style = {};
          if(data && data.openingBalance){
            style.borderLeft="none";
          }
          return {
            style:style 
          };
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? <span >{numberFormat(Number(value))}</span> : ''
        }
      },
    },
    {
      name: "totalPayment",
      label: "Payment",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? <span>{numberFormat(Number(value))}</span> : ''
        }
      },
    },
    {
      name: "balance",
      label: "Balance",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? <span className={classes.monthlyBalance}>{numberFormat(Number(value))}</span> : ''
        }
      },
    },
    {
      name: "collectionPercentage",
      label: "Collection(%)",
      options: {
        filter: true,
        sort: false,
        setCellProps:(value, rowIndex, columnIndex)=>{
          let data = muiData[rowIndex];
          let style = {};
          if(data && data.openingBalance){
            style.borderRight="none";
          }
          return {
            style:style 
          };
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? <LinearProgress value={Number(value)} /> : ''
        }
      },
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        empty: false,
        download: false,
        searchable: false,
        viewColumns: false,
        setCellProps:(value, rowIndex, columnIndex)=>{
          let data = muiData[rowIndex];
          let style = {};
          if(data && data.openingBalance){
            style.borderLeft="none";
          }
          return {
            style:style 
          };
        },
        customBodyRenderLite: (dataIndex, rowIndex) => {
          let data = muiData[dataIndex];
          return (data && !data.openingBalance?<ColumnActions>
            <ActionButton size="small" onClick={() => { handlePdfClick(dataIndex) }} className={classes.actionButton}>
              View PDF&nbsp;&nbsp;<PictureAsPdfIcon className={classes.actionPDF} />
            </ActionButton>
          </ColumnActions>:null);
        }
      },
    }
  ];
  const options = {
    rowsPerPage: 100,
    rowsPerPageOptions: [10, 100, 250],
    filterType: "multiselect",
    fixedHeader: true,
    tableBodyHeight: tableHeightWithSparklineTab,
    selectableRows: 'none',
    searchOpen: false,
    search: false,
    jumpToPage: false,
    download: false,
    filter: false,
    print: false,
    viewColumns: false,
    // customToolbar: (data) => {

    // },
    // customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

    // },
    // searchProps: {
    //   variant: "outlined",
    //   InputProps: {
    //     startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
    //   },
    //   onBlur: (e) => {
    //   },
    //   onKeyUp: (e) => {
    //   }
    // },
    searchPlaceholder: 'Search Payments',
    textLabels: {
      body: {
        noMatch: "No Data found",
        toolTip: "Sort",
        columnHeaderTooltip: column => `Sort for ${column.label}`
      }
    }
  };
  let totalPartyBalances = parties && parties.singlePartyMonthlyBalances && parties.singlePartyMonthlyBalances.totalPartyBalances ? parties.singlePartyMonthlyBalances.totalPartyBalances : 0

  const handlePdfClick = (value) => {
    setReportOpen(true);

    let singleData = parties.singlePartyMonthlyBalances && parties.singlePartyMonthlyBalances.monthlyBalances && parties.singlePartyMonthlyBalances.monthlyBalances[value] ? parties.singlePartyMonthlyBalances.monthlyBalances[value] : ""

    setMonthData(singleData.name);
    setMonthStartEpoch(singleData.monthStartEpoch);
    setMonthEndEpoch(singleData.monthEndEpoch);
  }

  const handleReportClose = () => {
    setReportOpen(false);
  }

  return (<>
    <TapLayout>
      <Grid container justify="flex-start" spacing={3} direction="row" alignItems="center">
        <Grid item>
          <TopCard title='Total Party Balance' color={"blue"} infoIcon={true} cardValue={numberFormat(totalPartyBalances)} infoTitle={"Total Party Balance"} infoText={"The total balance amount to be collected for all the trips with this party"} />
        </Grid>
      </Grid>
      <div className={classes.monthlyBalanceTableV1}>
        <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
      </div>
    </TapLayout>

    {reportOpen && <ReportsDialog open={reportOpen} name={"Monthly Balance Tab"} monthDate={monthData} monthStartEpochValue={monthStartEpoch} monthEndEpochValue={monthEndEpoch} onClose={handleReportClose} partyIdFromSingleParty={partId} />}
  </>)
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchGetSinglePartyMonthlyBalancesAction: (requestData, onSuccess, onError) =>
    dispatch(
      getMonthlyBalancesParty(
        requestData,
        onSuccess,
        onError
      )
    ),
});
const MonthlyBalancesTabWithRouter = withRouter(MonthlyBalancesTab);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MonthlyBalancesTabWithRouter);